<template>
    <modal :name="modalName" :adaptive="true" width="80%" height="auto" :scrollable="true">
        <div class="modal-header">
            <h5 class="modal-title">Branch information for: {{company.name}}</h5>
            <button type="button" class="close" @click="$modal.hide(modalName)"><i class="fas fa-times"></i></button>
        </div>
        <div class="modal-body">
            <p class="mt-2">Generatl information</p>
            <div class="row">
                <div class="col font-weight-bold">
                    <small>Company name:</small>
                </div>
                <div class="col">
                    <small>{{company.name}}</small>
                </div>
            </div>
            <div class="row">
                <div class="col font-weight-bold">
                    <small>Vat number:</small>
                </div>
                <div class="col">
                    <small>{{company.vat_number}}</small>
                </div>
            </div>
            <div class="row">
                <div class="col font-weight-bold">
                    <small>Target:</small>
                </div>
                <div class="col">
                    <small>{{company.target}}</small>
                </div>
            </div>
            <hr>
            <p class="mt-4">Contact information</p>
            <div class="row">
                <div class="col font-weight-bold">
                    <small>Address:</small>
                </div>
                <div class="col">
                    <small>{{company.address}}</small>
                </div>
            </div>
            <div class="row">
                <div class="col font-weight-bold">
                    <small>Country:</small>
                </div>
                <div class="col d-flex align-items-center">
                    <small>{{company.country_code}}</small><i :class="`ml-1 flag flag-${company.country_code && company.country_code.toLowerCase()}`"></i>
                </div>
            </div>
            <div class="row">
                <div class="col font-weight-bold">
                    <small>CEO name:</small>
                </div>
                <div class="col">
                    <small>{{company.ceo_name}}</small>
                </div>
            </div>
            <div class="row">
                <div class="col font-weight-bold">
                    <small>CEO email:</small>
                </div>
                <div class="col">
                    <small>{{company.ceo_email}}</small>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        props: {
            modalName: {
                type: String,
                required: true,
            },
            company: {
                type: Object,
                required: true
            }
        }
    };
</script>
// this.$modal.show(this.modalName);